/**
 * Combine all reducers in this file and export the combined reducers.
 * If we were to do this in store.ts, reducers wouldn't be hot reloadable.
 */

import { combineReducers } from 'redux';

import { reducer as avatar } from './Avatar';
import { reducer as login } from './Login';
import { reducer as recipe } from './Recipe';
import { reducer as user } from './User';
import { reducer as signup } from './Signup';
import { RootState } from './types';

export default combineReducers<RootState>({
  login,
  avatar,
  recipe,
  user,
  signup,
});
